import redirector from '../components/redirector'

export default redirector('/my-appointments')